import { useEffect } from "react";

import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { useAISummaryStore } from "../store/aiSummaryStore";

export default function useFetchAISummaryList() {
  const aiSummaryRepository = useService("repositories/ai-summary-repository");

  const {
    data,
    setData,
    loading,
    resLimit,
    currentPage,
    setLoading,
    searchText,
    setResultCount,
    chipData,
    readNotes,
    resetRightPanel,
  } = useAISummaryStore();

  const calculateOffset = () => {
    return (Number(currentPage) - 1) * resLimit || 0;
  };

  const fetchAISummaryData = async () => {
    try {
      setLoading(true);
      resetRightPanel();

      const queryParams = {};

      if (searchText.trim()) {
        queryParams.search = searchText;
      }

      if (resLimit && currentPage) {
        queryParams.limit = resLimit;
        queryParams.offset = calculateOffset();
      }

      if (readNotes !== null) {
        queryParams.read = readNotes;
      } else {
        delete queryParams["read"];
      }

      const response = await aiSummaryRepository.query(queryParams);
      const count = await aiSummaryRepository.getTotalCount();
      setData(response ?? []);
      setResultCount(count);
    } catch (error) {
      ApiRequestErrorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAISummaryData();
  }, [searchText, chipData, currentPage, readNotes, resLimit]);

  return {
    data,
    loading,
  };
}
